<template>
  <div>
    <div class="pa-2 cyan">
      <span class="text-subtitle-1 font-weight-bold white--text"
        >キャストを選んでコメント生成</span
      >
    </div>
    <v-container fluid>
      <v-row justify="space-between">
        <v-col cols="6" sm="3"> </v-col>
        <v-col cols="6">
          <div>
            <v-text-field
              v-model="castSearch"
              append-icon="mdi-magnify"
              label="（セラピスト名検索）"
              single-line
              hide-details
              clearable
              dense
              class="mb-2"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-data-table
      id="cast_table"
      :headers="castHeaders"
      :items="casts"
      :search="castSearch"
      item-key="id"
      :mobile-breakpoint="0"
      :items-per-page="-1"
      :footer-props="{
        'items-per-page-options': [50, 100, -1],
        'items-per-page-text': '表示件数',
      }"
    >
      <!-- eslint-disable-next-line -->
            <template v-slot:footer.page-text="props">
        {{ props.pageStart }} ～{{ props.pageStop }}件／全{{
          props.itemsLength
        }}件
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.shop_comment="{ item }">
        <v-icon class="pa-1" @click="genaiShopComment(item.id)"
          >mdi-store</v-icon
        >
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.cast_comment="{ item }">
        <v-icon class="pa-1" @click="genaiCastComment(item.id)"
          >mdi-face-woman</v-icon
        >
      </template>
      <!-- 画像 -->
      <!-- eslint-disable-next-line -->
      <template v-slot:item.image="{ item }">
        <v-avatar class="ma-1"
          ><v-img :src="setting.cdn + item.image"
        /></v-avatar>
      </template>
      <!-- 名前 -->
      <!-- eslint-disable-next-line -->
      <template v-slot:item.name="{ item }">
        {{ item.name }}
      </template>
      <!-- 公開 -->
      <!-- eslint-disable-next-line -->
      <template v-slot:item.enable="{ item }">
        <div class="pa-1">
          <v-chip
            v-if="item.is_enable"
            class="ma-2"
            color="primary"
            label
            small
          >
            公開中
          </v-chip>
          <v-chip v-else class="ma-2" label small> 非公開 </v-chip>
        </div>
      </template>
      <template v-slot:item.profile="{ item }">
        <span class="profile_span"
          >{{ item.profile_1 }}<br />{{ item.profile_2 }}</span
        >
      </template>
      <!-- eslint-disable-next-line -->
      <template v-slot:item.history="{ item }">
        <v-icon class="pa-1" @click="onHistory(item.id)"
          >mdi-comment-text-outline</v-icon
        >
      </template>
      <template v-slot:no-data> セラピストが登録されていません </template>
    </v-data-table>
    <history-drawer-component
      :type="null"
      :drawer="drawer"
      :cast_id="cast_id"
      @update:drawer="drawer = $event"
    ></history-drawer-component>
  </div>
</template>

<script>
import {
  ref,
  set,
  reactive,
  toRefs,
  defineComponent,
  watch,
  onMounted,
} from "@vue/composition-api";
import { useRouter } from "@/utils";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import utilDate from "@/common/utilDate.js";
import retryRequest from "@/common/retryRequest";
import historyDrawerComponent from "../generate/component/historyDrawer.vue";

export default defineComponent({
  props: ["shop_site_id"],
  components: {
    historyDrawerComponent,
  },
  setup(props, ctx) {
    const { router } = useRouter();
    const CastsRepository = repositoryFactory.get("casts");
    const ShopPropsRepository = repositoryFactory.get("shopProps");

    const state = reactive({
      // 履歴表示、cast_id
      drawer: false,
      cast_id: null,
      // 最大文字数
      shop_comment__char_count: 0,
      cast_comment__char_count: 0,
      // キャスト
      casts: [],
      castSearch: "",
      castSelected: [],
      castHeaders: [
        {
          text: "お店コメント",
          value: "shop_comment",
          sortable: false,
          align: "center",
          width: 80,
        },
        // {
        //   text: "セラピストコメント",
        //   value: "cast_comment",
        //   sortable: false,
        //   align: "center",
        //   width: 80,
        // },
        {
          text: "画像",
          value: "image",
          sortable: false,
          align: "center",
          class: "td_image",
          width: 80,
        },
        {
          text: "セラピスト名",
          value: "name",
          sortable: true,
          class: "td_name",
        },
        {
          text: "公開/非公開",
          value: "enable",
          sortable: true,
          width: 110,
        },
        {
          text: "プロフィール",
          value: "profile",
          sortable: false,
          class: "td_profile",
          width: 120,
        },
        {
          text: "入店日",
          value: "entry_date",
          sortable: true,
          class: "td_entry_date",
          width: 140,
        },
        {
          text: "コメント履歴",
          value: "history",
          sortable: false,
          class: "history",
        },
      ],
    });

    const getTargetCharCount = async () => {
      state.shop_comment__char_count = 0;
      const currentShop = store.getters["shops/currentShop"];
      let params = new URLSearchParams();
      params.append("shop_id", currentShop.id);
      params.append("key", "genai__shop_comment__char_count");
      let responseShopProps = await retryRequest(
        ShopPropsRepository.get_by_key,
        params
      );
      if (responseShopProps.data) {
        if (responseShopProps.data.value) {
          state.shop_comment__char_count = parseInt(
            responseShopProps.data.value
          );
        }
      }
      state.cast_comment__char_count = 0;
      params = new URLSearchParams();
      params.append("shop_id", currentShop.id);
      params.append("key", "genai__cast_comment__char_count");
      responseShopProps = await retryRequest(
        ShopPropsRepository.get_by_key,
        params
      );
      if (responseShopProps.data) {
        if (responseShopProps.data.value) {
          state.cast_comment__char_count = parseInt(
            responseShopProps.data.value
          );
        }
      }
    };

    onMounted(async () => {
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // 店舗設定・セラピストデータ取得
      const currentShop = store.getters["shops/currentShop"];

      // // 店舗設定取得 get_by_key
      // await getTargetCharCount();

      // セラピストデータ取得
      state.casts.splice(0);
      const params = new URLSearchParams();
      params.append("shop_id", currentShop.id);
      const responseCasts = await retryRequest(
        CastsRepository.list_profile,
        params
      );
      if (responseCasts.data) {
        for (let i = 0; i < responseCasts.data.length; i++) {
          const common_shop_site = [];
          for (let j = 0; j < responseCasts.data[i].prop.length; j++) {
            common_shop_site.push(responseCasts.data[i].prop[j]);
          }
          const p_age = common_shop_site.find(
            (r) => r.key == "cast__basic__age"
          );
          const p_tall = common_shop_site.find(
            (r) => r.key == "cast__basic__tall"
          );
          const text_age = "年齢:" + (!p_age ? "__" : p_age["value"] ?? "__");
          const text_tall =
            " 身長:" + (!p_tall ? "__" : p_tall["value"] ?? "__");
          const profile_1 = text_age + text_tall;
          const p_bust = common_shop_site.find(
            (r) => r.key == "cast__basic__bust"
          );
          const p_cup = common_shop_site.find(
            (r) => r.key == "cast__basic__cup"
          );
          const p_waist = common_shop_site.find(
            (r) => r.key == "cast__basic__waist"
          );
          const p_hip = common_shop_site.find(
            (r) => r.key == "cast__basic__hip"
          );
          const text_bust = "B:" + (!p_bust ? "__" : p_bust["value"] ?? "__");
          const text_cup =
            "(" +
            (!p_cup || p_cup == null ? "__" : p_cup["value"] ?? "__") +
            ")";
          const text_waist =
            " W:" + (!p_waist ? "__" : p_waist["value"] ?? "__");
          const text_hip = " H:" + (!p_hip ? "__" : p_hip["value"] ?? "__");
          const profile_2 = text_bust + text_cup + text_waist + text_hip;
          const tmpCast = responseCasts.data[i];
          tmpCast.profile_1 = profile_1;
          tmpCast.profile_2 = profile_2;

          const p_entry_date = common_shop_site.find(
            (r) => r.key == "cast__basic__entry_date"
          );
          let entry_date = "";
          if (p_entry_date && p_entry_date["value"]) {
            entry_date = utilDate.convertStrToFormatFull(p_entry_date["value"]);
          }
          tmpCast.entry_date = entry_date;

          tmpCast.newcast_flg = false;
          tmpCast.pickup_flg = false;

          state.casts.push(tmpCast);
        }
      }

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    });

    const genaiShopComment = async (cast_id) => {
      await router.push({
        name: "genai-generate",
        params: {
          type: "shop_comment",
          cast_id: cast_id,
        },
      });
    };

    const genaiCastComment = async (cast_id) => {
      await router.push({
        name: "genai-generate",
        params: {
          type: "cast_comment",
          cast_id: cast_id,
        },
      });
    };

    const onHistory = async (cast_id) => {
      state.cast_id = cast_id;
      state.drawer = !state.drawer;
    };

    // 返却オブジェクト定義
    return {
      setting,
      ...toRefs(state),
      genaiShopComment,
      genaiCastComment,
      onHistory,
    };
  },
});
</script>

<style scoped>
::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  padding: 0 6px !important;
}
::v-deep .mini label {
  font-size: 0.75em;
}

::v-deep .td_name {
  min-width: 100px;
  width: 200px;
}
::v-deep .td_profile,
::v-deep .td_entry_date,
::v-deep .td_newcast_flg,
::v-deep .td_pickup_flg {
  min-width: 120px;
}
.profile_span {
  font-size: 0.75em;
}
::v-deep .td_shop_site {
  min-width: 200px;
}
.shop_site_span {
  font-size: 0.75em;
  background-color: #fafafa;
  word-break: break-all;
}
</style>
